'use strict';

import { ScrollSpy } from '../../modules/scrollspy';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	// Init responsive table
	const $variants = $container.find('[data-variants]');
	if ($variants.length) {
		const hasHorizontalScrollbar = $variants[0].scrollWidth > $variants[0].clientWidth;
		if (hasHorizontalScrollbar) {
			$variants.addClass('variants-responsive--horizontal');
		}
	}

	const $gifts = $container.find('[data-gift]');

	// Disable unselected gifts
	if ($gifts.length) {

		const $giftSelectors = $container.find('[data-gift-selector]');

		const giftSelect = ($selector) => {

			const $currentGift = $selector.closest('[data-gift]');

			if ($selector.is(':checked') && $currentGift.length) {
				$currentGift.find('[name^="items[gift_"]').removeAttr('disabled');
				$container.find('[data-gift]').not($currentGift).find('[name^="items[gift_"]').attr('disabled', 'disabled');
			}
		};

		$container.on('click', $giftSelectors, (e) => {
			giftSelect($(e.target));
		});
	}

	const $header = $container.find('#header');
	const $headerWrapper = $container.find('#header_wrapper');
	const $headerMenuWrapper = $container.find('#header_menu_wrapper');
	const $sectionTabsScrollSpy = $container.find('[data-section-tabs]');
	const $productContentScrollspy = $container.find('#product_content_tabs').not('[data-render="tabs"]');

	let headerWrapperOuterHeight = $headerWrapper.is(':visible') ? $headerWrapper.outerHeight() : 0;
	// Recalculate headerWrapper height based in sticky header style
	if ($header.is('[data-sticky-header]') && $headerWrapper.is(':visible')) {
		const $headerClone = $header.clone();
		$headerClone.find('#header_menu_wrapper').remove();
		$headerClone.css('visibility', 'hidden');
		$headerClone.addClass('header--sticky');
		$headerClone.appendTo($container);
		headerWrapperOuterHeight = $headerClone.find('#header_wrapper').outerHeight();
		$headerClone.remove();
	}

	let offsetY =
		headerWrapperOuterHeight +
		($headerMenuWrapper.length && $headerMenuWrapper.is(':visible') ? $headerMenuWrapper.outerHeight() : 0);

	if ($productContentScrollspy.length && $sectionTabsScrollSpy.length) {

		offsetY =
			headerWrapperOuterHeight +
			($headerMenuWrapper.length && $headerMenuWrapper.is(':visible') ? $headerMenuWrapper.outerHeight() : 0) +
			$productContentScrollspy.outerHeight() + 16;
		const top =
			headerWrapperOuterHeight +
			($headerMenuWrapper.length && $headerMenuWrapper.is(':visible') ? $headerMenuWrapper.outerHeight() : 0);
			$productContentScrollspy.css({'top': top});

		$container.scrollspy({
			target: '#product_content_tabs',
			offset: offsetY + 1,
		});

		$('#product_content_tabs a').attr('data-offset-y', offsetY).attr('data-no-hash', 'true');
	} else {
		const $productContentTabs = $container.find('#product_content_tabs[data-render="tabs"]');
		
		offsetY =
			headerWrapperOuterHeight +
			($headerMenuWrapper.length && $headerMenuWrapper.is(':visible') ? $headerMenuWrapper.outerHeight() : 0) +
			$productContentTabs.outerHeight() + 16;

		const $tabLinks = $container.find('#product_content_tabs a.nav-link');

		if ($productContentTabs.length) {
			if (typeof $tabLinks.attr('data-offset-y') === 'undefined') {
				$tabLinks.attr('data-offset-y', offsetY)
			}
			if (typeof $tabLinks.attr('data-no-hash') === 'undefined') {
				$tabLinks.attr('data-no-hash', 'true')
			}
			if (typeof $tabLinks.attr('data-blink') === 'undefined') {
				$tabLinks.attr('data-blink', 'false')
			}
			if (typeof $tabLinks.attr('data-speed') === 'undefined') {
				$tabLinks.attr('data-speed', 0)
			}
		}
		else {
			$tabLinks.attr('href', '#');
		}
	}

	if ($('#product_summary_rating').length) {
		$('#product_summary_rating').attr('data-offset-y', offsetY).attr('data-no-hash', 'true');
	}

	// Populate 
	$('form[data-reservation-selection]').each((i, elem) => {

		const $form = $(elem); // jQuery object of the trigger element
    	const extraOptions = $form.data() || {}; // Retrieve extra options stored in data attributes
		if (extraOptions.target) {
			const $target = $(extraOptions.target); // Select the target element

			if ($target.length) {
				try {
					const data = JSON.parse($target.val());
					$form.find(`[name="reservation_interval"]`).val(data.start + ' - ' + data.end);
				} catch (error) {}
			}
		}
	});
});

const checkDateInterval = (interval) => {
    // Destructure the start and end parts from the split operation
    const [startStr, endStr] = interval.split(" - ");

    // Convert the strings into Date objects
    const startDate = new Date(startStr);
    const endDate = new Date(endStr);

    // Check if the dates are different
    return startDate.getTime() !== endDate.getTime();
};

/**
 * Handle reservation selection
 *
 * This function prevents the default form submission, extracts form data,
 * transforms it into a key-value object, and updates a target field if specified.
 * If no target is found, it resets the submit button.
 *
 * @this {HTMLElement} - The element that triggered the event
 * @param {JQuery.TriggeredEvent} e - The event object
 */
const reservationSelectionHandler = async function(e) {
    e.preventDefault(); // Prevent the default form submission

    const triggerElement = this; // Reference to the element that triggered the event
    const $trigger = $(this); // jQuery object of the trigger element
    const extraOptions = $trigger.data() || {}; // Retrieve extra options stored in data attributes
    const $button = $trigger.find('button[type=submit]'); // Find the submit button within the form

    // Serialize form data and transform it into a key-value object
    const formData = $trigger.serializeArray();
    const transformedData = formData.reduce((acc, { name, value }) => {
        if (acc[name]) {
            // If the key already exists, convert it into an array to store multiple values
            acc[name] = [].concat(acc[name], value);
        } else {
            acc[name] = value; // Otherwise, assign the value normally
        }
        return acc;
    }, {});

	const [[type, selectedInterval]] = Object.entries(transformedData);

    // If a target field is specified in data attributes, update it with the transformed data
    if (extraOptions.target) {
        const $target = $(extraOptions.target); // Select the target element
        const $trigger = $(extraOptions.trigger); // Select the trigger element
        const message = extraOptions.reservationMessage; // Select the message
        const type = extraOptions.reservationType; // Select the type

        if ($target.length && $trigger.length && selectedInterval) {
			if (checkDateInterval(selectedInterval)) {
				const reloadUrl = new URL($trigger.prop('href'));
				reloadUrl.searchParams.set('selected_interval', selectedInterval);
				$trigger.prop('href', reloadUrl.toString());
				const [start, end] = selectedInterval.split(' - ');
				
				// Update the target field with the transformed data in JSON format
				$target.val(JSON.stringify({start: start, end: end}));

				const getMessage = new Function('date_start', 'date_end', `return \`${message}\`;`);

				// Append selected interval to product specifications
				const $productDetailsContainer = $('.product-summary__top-details-left');
				if ($productDetailsContainer.length) {
					let $bookingMessageContainer = $('.product-summary__top-details-left .product-summary__info--booking');
					if (!$bookingMessageContainer.length) {
						$bookingMessageContainer = $('<div class="product-summary__info product-summary__info--booking"></div>');
						$productDetailsContainer.append($bookingMessageContainer);
					}
					
					let formatter;
					if (type !== 'day') {
						formatter = mpro.getDateTimeFormatter('medium', 'short');
					}
					else {
						formatter = mpro.getDateFormatter('medium');
					}
					$bookingMessageContainer.html(getMessage(formatter.format(new Date(start)), formatter.format(new Date(end))));
				}
	
				// Close all modals if the function exists
				mpro.closeAllModals && mpro.closeAllModals();
				return;
			}
        }
    }

    // If no target was found, remove the loading state and restore the submit button
    mpro.removeButtonLoading($button);
    mpro.restoreSubmitButton($button);
};


// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	// Handle reservation selection form submission
	$B.on('submit.selectReservation', 'form[data-reservation-selection]', reservationSelectionHandler);
});